<template>
  <div class="forgot-password flex flex-col">
    <template v-if="!showFormNewPassword">
      <h2
        class="page-title color-text font-bold text-28 text-text pt-10 tracking-tight text-center phone-verify-header"
      >
        {{ $t("We have sent an OTP to your Mobile") }}
      </h2>
      <p class="page-subtitle text-12 text-light_grey text-center">
        {{ $t("Please check your mobile number") }} {{ phone }} {{ paraTwo
        }}<br />
      </p>
      <div v-if="showUpdatePhone" class="mt-3 text-center">
        <span class="text-12 text-light_grey"
          >Do you want to update your Phone Number</span
        >
        <span
          class="text-12 text-primary font-bold"
          @click="$emit('update-phone')"
        >
          Click Here
        </span>
      </div>
      <!-- div class="flex-grow flex flex-col justify-center" -->
      <div class="input-box-parent">
        <ul class="phone-code flex justify-center">
          <li class="phone-code__item">
            <input
              type="number"
              maxlength="1"
              min="0"
              max="9"
              @input="updateValue(0)"
              v-model="verificationValue[0]"
              ref="input1"
            />
          </li>
          <li class="phone-code__item" :class="disableInput(0)">
            <input
              type="number"
              min="0"
              max="9"
              @input="updateValue(1)"
              v-model="verificationValue[1]"
              ref="input2"
            />
          </li>
          <li class="phone-code__item" :class="disableInput(1)">
            <input
              type="number"
              min="0"
              max="9"
              @input="updateValue(2)"
              v-model="verificationValue[2]"
              ref="input3"
            />
          </li>
          <li class="phone-code__item" :class="disableInput(2)">
            <input
              type="number"
              min="0"
              max="9"
              @input="updateValue(3)"
              v-model="verificationValue[3]"
              ref="input4"
            />
          </li>
        </ul>
      </div>
      <div class="table mx-auto mb-3 otp-btn" :class="btnStatus">
        <Button
          type="dynamic"
          :click-handler="checkSMS"
          :text="$t('Next')"
          classes="btn-dynamic"
        ></Button>
      </div>
      <p class="page-subtitle text-12 text-center text-light_grey">
        {{ $t("Didn't Receive?") }}
        <span
          class="phone-verify-link text-primary font-bold"
          @click="$emit('sendSMS', phone)"
          >{{ $t("Click Here") }}</span
        >
      </p>
    </template>

    <ResetPassword :phone="phone" v-else></ResetPassword>
  </div>
</template>

<script>
import Button from "../UI/Button";
import ResetPassword from "./ResetPassword";
export default {
  name: "PhoneVerification",

  props: {
    phone: {
      type: String,
      default: ""
    },
    through: {
      type: String,
      default: ""
    },
    header: {
      type: Boolean,
      default: false
    },
    paraTwo: {
      type: String,
      default: ""
    },
    showUpdatePhone: {
      type: Boolean,
      default: false
    },
    endPoint: {
      type: String,
      default: "user/checksms"
    }
  },

  components: {
    ResetPassword,
    Button
  },

  data: function() {
    return {
      verificationValue: [],
      temp: null,
      showFormNewPassword: false
    };
  },

  mounted() {
    this.$setState("step_header", this.header);
  },

  computed: {
    checkCode() {
      return (
        this.verificationValue["0"] &&
        this.verificationValue["1"] &&
        this.verificationValue["2"] &&
        this.verificationValue["3"]
      );
    },
    btnStatus() {
      return {
        "active-button btn-custom": this.checkCode,
        "disable-button": !this.checkCode
      };
    },
    isSuccess() {
      return this.through == "login" || this.through == "update";
    }
  },

  methods: {
    disableInput(index) {
      return {
        "disables-input": !this.verificationValue[index]
      };
    },
    updateValue: function(pos) {
      const value = this.verificationValue[pos];
      const str = String(value);
      if (str.length > 1) {
        this.verificationValue[pos] = str[0];
      }
      const nextRef = "input" + (pos + 2);
      const prevRef = "input" + pos;
      if (value && pos < 3) {
        setTimeout(() => {
          this.$refs[nextRef].focus();
        }, 100);
      } else if (!value && pos >= 0 && pos < 4) {
        setTimeout(() => {
          this.$refs[prevRef].focus();
        }, 100);
      }
    },
    async checkSMS() {
      const payload = {
        phone: this.phone,
        sms: this.verificationValue.join("")
      };
      const res = await this.$http.post(this.endPoint, payload);
      if (!res.status) return;
      if (this.isSuccess) {
        this.$emit("success");
        return;
      }
      this.showFormNewPassword = true;
    }
  }
};
</script>
<style>
.phone-code__item {
  border: 1px solid var(--text-color);
}
</style>
